<div id="notfound row">
    <div class="notfound col-6">
        <div class="notfound-404">
            <h3>{{pageNotFoundHeaderText}}</h3>
            <h1><span class="four-zero-4">{{pageNOtFoundErrorCode}}</span></h1>
        </div>
        <h2>{{pageNotFoundErrorMessage}}</h2>
    </div>
</div>